<template>
  <div class="index-container">
    <swiper
      :options="swiperOption"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(item, index) in swiperList"
        :key="index"
        :style="{
          background: `url(${item.banner}) no-repeat center center`,
          backgroundSize: 'auto 100%',
          backgroundColor: index != 0 ? '#d5e3f9' : '#D8E9FE',
        }"
      >
        <template v-if="item.href">
          <a :href="item.href" target="_blank"> </a>
        </template>
        <template v-else>
          <img v-viewer :src="item.img" alt="" />
        </template>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="group advantage">
      <div class="w">
        <div v-inview="'animate__lightSpeedInLeft'" class="group-title">
          平台优势
        </div>
        <div class="advantage-list">
          <div
            class="advantage-item"
            v-for="(item, index) in advantageList"
            :key="index"
          >
            <img :src="item.bgimg" alt="" />
            <div class="item-con">
              <div class="item-con-title">{{ item.title }}</div>
              <div class="item-con-line"></div>
              <div class="item-con-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="group popular">
      <div class="w">
        <div v-inview="'animate__lightSpeedInRight'" class="group-title">
          热门功能
        </div>
        <div class="popular-list">
          <div
            class="popular-item"
            v-for="(item, index) in popularList"
            :key="index"
          >
            <div class="top">
              <img :src="item.icon" alt="" />
              <div class="title">{{ item.title }}</div>
            </div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="group partner" style="background-color: #f6f7f9">
      <div class="w">
        <div v-inview="'animate__lightSpeedInLeft'" class="group-title">
          合作伙伴
        </div>
        <div class="partner-list">
          <div
            v-for="(item, index) in partnerList"
            :key="index"
            class="partner-item"
          >
            <div class="partner-icon">
              <img :src="item" alt="" />
            </div>
            <div class="tjl-icon">
              <img src="../assets/logo.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="group dynamic">
      <div class="w">
        <div v-inview="'animate__lightSpeedInRight'" class="group-title">
          行业动态
        </div>
        <div class="dynamic-list">
          <div
            class="dynamic-item"
            v-for="(item, index) in dynamicList"
            :key="index"
          >
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="tit line1">{{ item.title }}</div>
              <div class="desc line2">{{ item.desc }}</div>
              <div class="time">
                <div style="margin-right: 23px">更新日志</div>
                <div>{{ item.time }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="more">
          <div class="more-btn">查看更多</div>
        </div> -->
      </div>
    </div>

    <div class="group data">
      <div class="w">
        <div class="data-list">
          <div
            v-inview="'animate__zoomInDown'"
            class="data-item"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <img :src="item.icon" alt="" />
            <div class="info">
              <div class="num">{{ item.num }}</div>
              <div class="tit">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="saas">
      <div class="saas-main w">
        <div class="saas-title">专注私域运营工具，做优质工具商</div>
        <div class="saas-desc">
          致力于为个人及各类中小型企业提供高质量SAAS软件服务
        </div>
        <a
          class="saas-btn"
          href="https://saas.tuielf.com/supplier"
          target="_blank"
        >
          免费试用
        </a>
      </div>
    </div>

    <div class="kefu" :class="isShowKefu ? 'show' : 'hide'">
      <img src="../assets/qrcode.jpg" alt="客服二维码" />
      <div class="txt">微信扫码联系客服</div>
    </div>
    <div class="tools-bar-container">
      <div class="tools-bar-list">
        <div
          class="tools-bar-item"
          @mouseenter="showKefu"
          @mouseleave="hideKefu"
        >
          <img class="icon" src="../assets/wechat.png" alt="" />
          <div class="txt">微信咨询</div>
        </div>
        <div class="tools-bar-item" @click="scrollTop">
          <img class="icon" src="../assets/top.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import checkHost from "../../public/host";
export default {
  name: "index",
  components: {},
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        pagination: {
          el: ".swiper-pagination",
          // 设置点击可切换
          clickable: true,
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 设置自动轮播
        autoplay: {
          delay: 5000,
        },
        // 设置轮播可循环
        loop: true,
      },
      isShowKefu: 0,
      beian: {},
      swiperList: [
        {
          banner: require("../assets/banner1.png"),
          href: "https://saas.tuielf.com/supplier",
        },
        {
          banner: require("../assets/banner2.png"),
          img: require("../assets/qrcode.jpg"),
        },
        {
          banner: require("../assets/banner3.png"),
          href: "https://saas.tuielf.com/supplier",
        },
      ],
      advantageList: [
        {
          title: "全生态深度覆盖",
          desc: "深度整合微信全生态（企微 / 公众号 / 小程序）与支付宝全生态（小程序 / 社群），构建跨平台通信体系。",
          bgimg: require("../assets/advantage_1.png"),
        },
        {
          title: "高效集成开发",
          desc: "采用低代码 / 无代码集成模式，API 接口标准化设计，快速对接现有系统并缩短开发周期。",
          bgimg: require("../assets/advantage_2.png"),
        },
        {
          title: "电商专项赋能",
          desc: "配备专业电商团队，提供自动化商品上架功能及售后业务全流程支持，提升电商运营效率。",
          bgimg: require("../assets/advantage_3.png"),
        },
        {
          title: "全天候运维保障",
          desc: "7×24 小时专业运维团队实时监控，保障高并发场景下通信服务的稳定性、安全性与高效性。",
          bgimg: require("../assets/advantage_4.png"),
        },
      ],
      popularList: [
        {
          icon: require("../assets/popular1.png"),
          title: "多平台",
          desc: "京东、拼已对接淘宝、多多、美团、饿了么及本地生活等联盟",
        },
        {
          icon: require("../assets/popular2.png"),
          title: "多账号管理",
          desc: "可批量管理运营公众号，运营更轻松",
        },
        {
          icon: require("../assets/popular3.png"),
          title: "签到打卡",
          desc: "多种打卡页面选择，引导用户持续打卡，提升用户留存率",
        },
        {
          icon: require("../assets/popular4.png"),
          title: "权益卡券",
          desc: "海量卡券权益，可批量选购，API接口技术对接",
        },
        {
          icon: require("../assets/popular5.png"),
          title: "被关注回复",
          desc: "可设置 文本/图文/图片/小程序卡片/网页卡片 等消息类型",
        },
        {
          icon: require("../assets/popular6.png"),
          title: "渠道码",
          desc: "多渠道引导关注公众号，实时查看不同渠道的粉丝数据",
        },
        {
          icon: require("../assets/popular7.png"),
          title: "中间页",
          desc: "支持在微信生态推广其它平台的口令、链接等，通过生成中间页的形式进行安全推广",
        },
        {
          icon: require("../assets/popular8.png"),
          title: "多渠道运营",
          desc: "主要用于公众号/小程序体系搭建，可以让你更好的进行活动营销以及粉丝运营",
        },
      ],
      partnerList: [
        require("../assets/partner1.png"),
        require("../assets/partner2.png"),
        require("../assets/partner3.png"),
        require("../assets/partner4.png"),
        require("../assets/partner5.png"),
        require("../assets/partner6.png"),
        require("../assets/partner7.png"),
        require("../assets/partner8.png"),
        require("../assets/partner9.png"),
        require("../assets/partner10.png"),
      ],
      dynamicList: [
        {
          img: require("../assets/dynamic1.png"),
          title: "外卖平台拓展生鲜业务，打造 “即时鲜配” 新赛道",
          desc: "头部外卖平台官宣布局生鲜即时配送，联合产地直采优质果蔬、肉禽，构建 “线上下单 + 30 分钟达” 供应链。首批试点城市订单量爆发式增长，商家借助平台流量实现营收翻倍，推动生鲜零售场景变革。",
          time: "2025年06月17日 13:42:03",
        },
        {
          img: require("../assets/dynamic2.png"),
          title: "外卖企业发力 B 端赋能，推出商家数字化运营方案",
          desc: "针对中小餐饮痛点，外卖平台发布 B 端专属工具包，涵盖智能选址、菜品优化、会员体系搭建等功能。合作商家经数字化改造后，复购率提升 22%，营销成本降低 18% ，助力堂食外卖双渠道增长。",
          time: "2025年06月17日 08:11:35",
        },
        {
          img: require("../assets/dynamic3.png"),
          title: "外卖行业跨界融合，“餐饮 + 零售” 模式落地生金",
          desc: "连锁餐饮品牌携手外卖平台，推出 “堂食外卖 + 零售预制菜” 一体化方案。消费者下单餐饮可加购预制菜，商家库存周转效率提升 35%，单店营收结构优化，开辟零售新增长点。",
          time: "2025年06月18日 17:44:49",
        },
        {
          img: require("../assets/dynamic4.png"),
          title: "外卖平台布局海外市场，复制 “即时配送” 成功经验",
          desc: "国内头部外卖企业加速出海，在东南亚、拉美落地本土化平台，整合本地商家、骑手资源。凭借成熟运营体系，海外市场首月订单突破百万单，助力中国模式输出，开拓全球化商业版图。",
          time: "2025年06月17日 22:42:20",
        },
        {
          img: require("../assets/dynamic5.png"),
          title: "外卖平台引入 AI 调度系统，提升配送效率与体验",
          desc: "头部外卖平台部署智能 AI 调度算法，结合实时路况、骑手状态动态派单。试点区域骑手日均配送单量增加 15%，超时率下降 8% ，用户催单投诉减少，实现配送效率与服务体验双升级。",
          time: "2025年06月18日 05:19:08",
        },
        {
          img: require("../assets/dynamic6.png"),
          title: "外卖 + 文旅融合，打造景区 “即点即达” 消费生态",
          desc: "旅游城市试点 “景区外卖” 服务，覆盖特色小吃、文创商品即时配送，游客在热门景点扫码下单，30 分钟内可享本地风味或纪念周边。首月带动景区非门票消费增长 22%，激活文旅消费新场景。",
          time: "2025年06月13日 08:19:40",
        },
      ],
      dataList: [
        {
          icon: require("../assets/data1.png"),
          num: "10万+",
          title: "入驻推精灵",
        },
        {
          icon: require("../assets/data2.png"),
          num: "100+",
          title: "入驻品牌",
        },
        {
          icon: require("../assets/data3.png"),
          num: "1000万+",
          title: "年订单",
        },
        {
          icon: require("../assets/data4.png"),
          num: "1000万+",
          title: "年分发佣金",
        },
        {
          icon: require("../assets/data5.png"),
          num: "1亿+",
          title: "覆盖用户",
        },
      ],
    };
  },
  created() {
    // const beian = checkHost(window.location.host);
    const beian = localStorage.getItem("beian");
    this.beian = JSON.parse(beian);
  },
  mounted() {},
  methods: {
    showKefu(i) {
      this.isShowKefu = true;
    },
    hideKefu() {
      this.isShowKefu = false;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    onSwiper() {},
    onSlideChange() {},
  },
};
</script>

<style lang="less" scoped>
.index-container {
  .group {
    padding: 60px 0;

    .group-title {
      margin-bottom: 30px;
      font-weight: 600;
      font-size: 36px;
      text-align: center;
      color: #1d2129;
    }
  }

  .swiper-container {
    height: 480px;
    overflow: hidden;
    // background-color: #d5e3f9;
    // box-shadow: 0 2px 10px 0 rgba(51, 51, 51, 0.1);
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 18px;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide a,
  .swiper-slide img {
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  .advantage {
    .advantage-list {
      padding: 0 16px;
      display: flex;
      align-items: center;
      column-gap: 21px;

      .advantage-item {
        position: relative;
        flex: 1;
        // height: 320px;
        background-color: #eeeeee;
        border-radius: 8px;

        .item-con {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding: 30px 20px;
          border-radius: 8px;
          z-index: 2;
          transition: all 0.5s;

          .item-con-title {
            margin-bottom: 10px;
            font-weight: 500;
            font-size: 20px;
            transition: all 0.5s;
          }
          .item-con-line {
            width: 16px;
            height: 3px;
            background: #4080ff;
          }
          .item-con-desc {
            margin-top: 24px;
            color: #4e5969;
            transition: all 0.5s;
          }
        }

        &:hover {
          .item-con {
            background-color: rgba(0, 0, 0, 0.5);
            .item-con-title,
            .item-con-desc {
              color: #fff;
            }
          }
        }
      }
    }
  }

  .popular {
    .popular-list {
      padding: 0 16px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;

      .popular-item {
        padding: 20px;
        height: 154px;
        box-shadow: 4px 4px 8px 0px rgba(86, 110, 121, 0.08);
        border-radius: 6px;
        transition: all 0.5s;

        .top {
          margin-bottom: 20px;
          display: flex;
          align-items: center;

          img {
            margin-right: 12px;
            width: 34px;
            height: 34px;
          }

          .title {
            font-weight: 500;
            font-size: 20px;
          }
        }

        .desc {
          color: #4e5969;
        }

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .partner {
    .partner-list {
      padding: 0 16px;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 30px;

      .partner-item {
        position: relative;
        height: 60px;
        background-color: #fff;
        border-radius: 4px;
        transform-style: preserve-3d;
        transition: all 0.5s;

        .partner-icon,
        .tjl-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 120px;
            // height: 32px;
          }
        }

        .partner-icon {
          background-color: #fff;
          z-index: 1;
          transform: translateZ(30px);
        }

        .tjl-icon {
          background-color: #f5f6f7;
          transform: translateY(30px) rotateX(-90deg);
        }

        &:hover {
          // box-shadow: 6px 6px 10px 0px rgba(86, 110, 121, 0.08);
          transform: rotateX(90deg);
        }
      }
    }
  }

  .dynamic {
    .dynamic-list {
      position: relative;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      // column-gap: 30px;

      .dynamic-item {
        padding: 16px;
        display: flex;
        align-items: center;
        height: 188px;
        border-bottom: 1px solid #e5e6eb;
        // overflow: hidden;
        box-sizing: border-box;

        img {
          margin-right: 15px;
          width: 186px;
          height: 128px;
          background-color: #d9d9d9;
        }

        .info {
          flex: 1;
          padding: 2px 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          max-width: 100%;
          height: 128px;
          box-sizing: border-box;

          .tit {
            width: 100%;
            font-weight: 500;
            font-size: 18px;
          }

          .desc {
            width: 100%;
            font-size: 14px;
          }

          .time {
            width: 100%;
            display: flex;
            font-size: 13px;
            color: #4e5969;
          }
        }
      }
    }

    .more {
      margin-top: 30px;
      display: flex;
      justify-content: center;

      .more-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 98px;
        height: 38px;
        font-size: 14px;
        color: #86909c;
        border-radius: 38px;
        border: 1px solid #c9cdd4;
      }
    }
  }

  .data {
    background-color: #f6f7f9;

    .data-list {
      display: flex;
      align-items: center;

      .data-item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 0;
        flex: 1;
        border-right: 1px solid #e5e6eb;

        &:last-child {
          border-right: 0;
        }

        img {
          margin-right: 16px;
          width: 48px;
          height: 48px;
        }

        .info {
          .num {
            font-weight: 500;
            font-size: 18px;
          }
          .tit {
            font-size: 14px;
            color: #4e5969;
          }
        }
      }
    }
  }

  .saas {
    background-color: #3e67ed;

    .saas-main {
      padding: 0 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 522px;

      .saas-title {
        margin-bottom: 30px;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
      }

      .saas-desc {
        margin-bottom: 50px;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
      }

      .saas-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 46px;
        background: #ffffff;
        border-radius: 46px;
        cursor: pointer;
      }
    }
  }
}

.tools-bar-container {
  position: fixed;
  right: 30px;
  bottom: 100px;
  z-index: 999;

  .tools-bar-list {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid #4080ff;
    border-radius: 4px;

    .tools-bar-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      border-bottom: 1px solid #4080ff;
      cursor: pointer;

      &:last-child {
        border-bottom: 0;
      }

      .icon {
        width: 40px;
        height: 40px;
      }

      .txt {
        font-size: 12px;
        color: #4080ff;
      }
    }
  }
}

.kefu {
  position: fixed;
  bottom: 100px;
  right: 120px;
  padding: 10px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  z-index: 999;
  border: 1px solid #4080ff;

  img {
    width: 150px;
    height: 150px;
  }
  .txt {
    margin-top: 10px;
    font-size: 14px;
    text-align: center;
    color: #333;
  }
}

.kefu.show {
  display: block;
}
.kefu.hide {
  display: none;
}

@media (min-width: 992px) and (max-width: 1199px) {
  .index-container {
    .swiper-container {
      height: 400px;
    }
    // .swiper-slide {
    // background-size: 100% 100% !important;
    // }
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .index-container {
    .swiper-container {
      height: 300px;
    }
    // .swiper-slide {
    // background-size: 100% 100% !important;
    // }

    .advantage {
      .advantage-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
      }
    }

    .popular {
      .popular-list {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
      }
    }

    .partner {
      .partner-list {
        grid-template-columns: repeat(5, 1fr);
        gap: 16px;
      }
    }

    .dynamic {
      .dynamic-list {
        grid-template-columns: repeat(1, 1fr);
        column-gap: 20px;
      }
    }
  }
}

@media (max-width: 767px) {
  .index-container {
    .swiper-container {
      height: 180px;
    }
    // .swiper-slide {
    // background-size: 100% 100% !important;
    // }

    .advantage {
      .advantage-list {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 16px;

        .advantage-item {
          margin: 0 auto;
          width: 320px;
        }
      }
    }

    .popular {
      .popular-list {
        grid-template-columns: repeat(1, 1fr);
        gap: 16px;
      }
    }

    .partner {
      .partner-list {
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
      }
    }

    .dynamic {
      .dynamic-list {
        grid-template-columns: repeat(1, 1fr);
        column-gap: 20px;

        .dynamic-item {
          .info {
            .time {
              flex-direction: column;
            }
          }
        }
      }
    }

    .data {
      .data-list {
        flex-direction: column;
        gap: 20px;

        .data-item {
          width: 150px;
          justify-content: flex-start;
          border-right: 0;
        }
      }
    }
  }

  .tools-bar-container {
    right: 20px;
    bottom: 80px;

    .tools-bar-list {
      .tools-bar-item {
        width: 50px;
        height: 50px;

        .icon {
          width: 20px;
          height: 20px;
        }

        .txt {
          font-size: 10px;
        }
      }
    }
  }

  .kefu {
    position: fixed;
    bottom: 80px;
    right: 80px;
    padding: 10px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    z-index: 999;
    border: 1px solid #4080ff;

    img {
      width: 150px;
      height: 150px;
    }
    .txt {
      margin-top: 10px;
      font-size: 14px;
      text-align: center;
      color: #333;
    }
  }
}
</style>
